import React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import { AtsCandidateFeedbacksDocument, CandidateDetailFragment } from 'generated/resources/graphql'
import { range } from 'lodash'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import { useGetEvaluationFormsByJobPostings } from 'modules/ats/hooks/evaluationForms/useGetEvaluationFormsByJobPostings'

import { Feedback } from '../Feedbacks/Feedback'
import { FeedbackSkeletonDisplay } from '../Feedbacks/Feedback/FeedbackSkeletonDisplay'
import { FeedbackNew } from '../Feedbacks/FeedbackNew'

interface Props {
  candidate: CandidateDetailFragment
}

export const CandidateFeedbacks = ({ candidate }: Props) => {
  const { data, loading } = useQuery(AtsCandidateFeedbacksDocument, {
    variables: {
      candidateId: candidate.id,
    },
  })
  const [showNewFeedbackEditor, setShowNewFeedbackEditor] = React.useState(false)
  const jobIds = candidate.applications.map((a) => a.relatedJobPosting.id)
  const { evaluationForms } = useGetEvaluationFormsByJobPostings(jobIds)
  const localStorageKey = `${LOCAL_STORAGE_KEYS.atsNewCandidateFeedbackDraft}:${candidate.id}`
  const [draftNote, setDraftNote] = useLocalStorage<string>(localStorageKey)

  const feedbacks = data?.ats.feedbacksConnection.nodes || []

  return (
    <Box gap="s16">
      {loading ? (
        range(3).map((n) => <FeedbackSkeletonDisplay key={n} />)
      ) : (
        <>
          {!showNewFeedbackEditor && !draftNote && (
            <Button
              type="secondary"
              disabled={showNewFeedbackEditor}
              onClick={() => setShowNewFeedbackEditor(true)}
              iconName="add"
            >
              {i18n.t('ats.application_details.evaluations.new_note')}
            </Button>
          )}
          {(showNewFeedbackEditor || draftNote) && (
            <FeedbackNew
              candidateId={candidate.id}
              draftNote={draftNote}
              onDraftChange={setDraftNote}
              closeNote={() => {
                setShowNewFeedbackEditor(false)
                setDraftNote('')
              }}
              allowRestrictedComments={false}
            />
          )}
          {feedbacks.map((feedback) => (
            <Feedback
              key={feedback.id}
              feedback={feedback}
              evaluationForm={evaluationForms.find(
                (evalForm) => evalForm.id === feedback.atsEvaluationFormsId
              )}
              restrictedCommentsAvailable={false}
            />
          ))}
        </>
      )}
    </Box>
  )
}
